import { render, staticRenderFns } from "./TypedSurveyFiles.vue?vue&type=template&id=5fe455f3&scoped=true"
import script from "./TypedSurveyFiles.vue?vue&type=script&lang=js"
export * from "./TypedSurveyFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe455f3",
  null
  
)

export default component.exports